// localStorage can throw (private mode, quota, disabled storage); preferences
// then simply do not persist.
export const storage = {
  get(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  set(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch {
      // not persistable here
    }
  },
  remove(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch {
      // not persistable here
    }
  },
};
